<mat-icon *ngIf="!showPopover" class="attributes-button" (click)="openAttributesPopup()">settings
</mat-icon>

<ng-container *ngIf="showPopover">
    <div
        cdkOverlayOrigin
        #popoverOrigin="cdkOverlayOrigin"
        (mouseenter)="setPopoverOpen(true)"
        (mouseleave)="setPopoverOpen(false)"
        (focusin)="setPopoverOpen(true)"
        (focusout)="setPopoverOpen(false)">
        <mat-icon class="attributes-button" (click)="openAttributesPopup()" [ngClass]="{
            'noAttributes': !areAttributesFlagsVisible(attributesStatistic)
       }">settings
        </mat-icon>
    </div>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="popoverOrigin"
        [cdkConnectedOverlayOpen]="popoverOpen"
        [cdkConnectedOverlayPositions]="popoverPositions"
        [cdkConnectedOverlayHasBackdrop]="false"
        (overlayOutsideClick)="setPopoverOpen(false)"
        (detach)="setPopoverOpen(false)">
        <div *ngIf="areAttributesFlagsVisible(attributesStatistic)" class="attributes-popover">
            <ziq-calibration-set-attributes-icons [attributesFlags]="attributesStatistic">
            </ziq-calibration-set-attributes-icons>
        </div>
    </ng-template>
</ng-container>
